import billing from '@/billing/reducers/billing';
import plan from '@/billing/reducers/plan';

import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({
  billing,
  plan,
});
